<script>
import store from '@state/store'
import { debounce } from 'debounce'
import { authComputed } from '@state/helpers'
import AdminTable from '@components/admin-table.vue'
import { USERS_TABLE_FIELDS } from '@adminCompanies/constant'

export default {
  components: {
    AdminTable,
  },
  props: {
    tableType: { type: String, required: true },
    companyId: { type: [String, Number], required: true },
    groupId: { type: [String, Number], required: true },
    noNewBtn: { type: Boolean, required: false, default: false },
    noEditBtn: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      tableFields: USERS_TABLE_FIELDS,
      page: 1,
      perPage: 10,
      lists: [],
      total: 0,
      filter: {},
      sort: {},
      loaded: false,
    }
  },
  computed: {
    ...authComputed,
    computedTableType() {
      if (this.tableType === 'ADMIN_USERS') {
        return 'USERS'
      }
      return this.tableType
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loaded = false
      this.lists = []
      this.fetchUsers()
    },
    fetchUsers() {
      let params = {
        groupId: this.groupId,
        filter: this.filter,
        page: this.page,
        per_page: this.perPage,
        sort: this.sort,
      }

      if (this.tableType === 'ADMIN_USERS') {
        params = Object.assign(params, { adminsOfGroup: this.groupId })
      }
      if (this.tableType === 'EVENT_ADMINS') {
        params = Object.assign(params, { eventAdminsOfGroup: this.groupId })
      }
      if (this.tableType === 'USERS') {
        params = Object.assign(params, { includeInvites: true })
      }

      store
        .dispatch('adminUsers/fetchLists', params)
        .then((result) => {
          this.lists = result.data
          this.total = result.total
        })
        .catch((err) => {
          alert(err.message || 'Something went wrong.')
        })
        .finally(() => {
          this.loaded = true
        })
    },
    setPage({ page, perPage }) {
      this.page = page
      this.perPage = perPage
      this.fetchData()
    },
    setFilterParams: debounce(async function setFilterParams(params) {
      this.filter = { ...params }
      this.fetchData()
    }, 500),
    setSortParams(params) {
      this.sort = { ...params }
      this.fetchData()
    },
    deleteItem(id) {
      let action = ''
      if (this.tableType === 'USERS') {
        action = 'adminUsers/removeUserOfGroup'
      } else if (this.tableType === 'ADMIN_USERS') {
        action = 'adminUsers/removeAdminOfGroup'
      } else if (this.tableType === 'EVENT_ADMINS') {
        action = 'adminUsers/removeEventAdminOfGroup'
      }
      store
        .dispatch(action, { groupId: this.groupId, userId: id })
        .then((result) => {
          if (result === true) {
            this.fetchData()
          }
        })
        .catch((err) => {
          alert(err.message || 'Something went wrong.')
        })
    },
  },
}
</script>

<template>
  <AdminTable
    :table-type="computedTableType"
    :table-fields="tableFields"
    :no-new-btn="noNewBtn"
    :no-edit-btn="noEditBtn"
    :total-num="total"
    :list-data="lists"
    :data-loaded="loaded"
    :cur-page="page"
    :per-page="perPage"
    @table-set-sort-params="setSortParams"
    @table-set-filter-params="setFilterParams"
    @table-delete-item="deleteItem"
    @table-set-page="setPage"
  />
</template>
